(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[854],{

/***/ 6545:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/register",
      function () {
        return __webpack_require__(6473);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Register; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2031);
/* harmony import */ var _backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _templates_account__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9075);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2310);




var RegisterTemplate = _templates_account__WEBPACK_IMPORTED_MODULE_2__/* ["default"].register */ .Z.register;
var authOptions = {
    autoRedirect: true,
    defaultRoute: "/account/orders",
    id: "withRegister"
};
var __N_SSG = true;
function Register(param) {
    var initialSettings = param.settings;
    var liveSettings = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__.useSettings)();
    var settings = liveSettings || initialSettings;
    // will redirect to account if signed in
    var authenticated = (0,_backpackjs_storefront__WEBPACK_IMPORTED_MODULE_1__.useCustomerAuth)(authOptions).authenticated;
    return authenticated === false ? RegisterTemplate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RegisterTemplate, {
        action: "register",
        settings: settings
    }) : "Register template not provided" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_3__/* .AccountsAuthLoader */ .iT, {}) // while you are auto redirect
    ;
};


/***/ }),

/***/ 9075:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    // logged out
    activate: null,
    login: null,
    register: null,
    "reset-password": null,
    // logged in
    "address-book": null,
    "edit-profile": null,
    order: null,
    orders: null
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(6545); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);